// src/ProductDetailsPage.jsx
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProductById } from './Product.jsx';
import './ProductDetailPage.css';

const ProductDetailsPage = () => {
  const { id } = useParams(); // get product ID from URL
  const navigate = useNavigate();
  const product = getProductById(parseInt(id));

  if (!product) {
    return <div>Product not found!</div>;
  }

  return (
    <div className="product-detailspage-container">
      <button onClick={() => navigate(-1)} className="productdetailpage-back-btn">
        
      </button>

      <div className="product-details-main">
        {/* Sticky Image Container */}
        <div className="product-image-container">
          <img
            src={product.image}
            alt={product.name}
            className="product-details-image"
          />
        </div>

        {/* Scrollable Content Container */}
        <div className="product-detailspage-info">
          <h1>{product.name}</h1>
          <p>{product.description}</p>

          {/* Available Packings and Usage Areas sections */}
          <div className="product-details-sections">
            <div className="product-section">
              <h4>Available Packings:</h4>
              <p className="product-packings">
                {Object.entries(product.availablePackings)
                  .map(([unit, sizes]) => `${sizes.join(', ')} ${unit}`)
                  .join(' | ')}
              </p>
            </div>

            <div className="product-section">
              <h4>Usage Areas:</h4>
              <p className="product-usage-areas">
                {product.usageAreas.join(', ')}
              </p>
            </div>
          </div>

          {/* Benefits Section - Now at the bottom */}
          <div className="benefits-section">
            <h4>Benefits:</h4>
            <ul>
              {product.benefits.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsPage;